import React, { useEffect } from 'react';
import { IconFont, useFocusIdx } from '@bay-email/editor';
import { RadioGroupField } from '../../../components/Form';
import { t } from '@bay-email/core';
import { useField } from 'react-final-form';

const options = [
	{
		value: 'normal',
		label: t('Normal'),
	},
	{
		value: 'italic',
		label: <IconFont iconName='icon-italic' />,
	},
];

export function FontStyle({ name }: { name?: string }) {
	const { focusIdx } = useFocusIdx();

	const fieldName = name || `${focusIdx}.attributes.font-style`;
	const { input } = useField<string | undefined>(fieldName, {
		subscription: {
			value: true,
		},
	});

	useEffect(() => {
		if (!input.value && focusIdx) {
			input.onChange('normal');
		}
	}, [focusIdx, input]);

	return (
		<RadioGroupField
			label={t('Font style')}
			name={fieldName}
			options={options}
			type='button'
			formItem={{ style: { marginBottom: '8px' } }}
		/>
	);
}
